


































































































import Vue from "vue";
import Component from "vue-class-component";
import { Prop } from "vue-property-decorator";
import rules from "../../utils/rules";

@Component
export default class CreateSocialMediaDialog extends Vue {
  @Prop() dialogCreate!: boolean;

  $refs!: {
    formCreate: HTMLFormElement;
  };

  generalRules = [rules.notEmpty];
  valid = true;
  loadingCreate = false;
  snackbarSuccessCreate = false;
  snackbarErrorCreate = false;
  url = "";
  icon = "";
  name = "";

  private cancelCreate(): void {
    this.$emit("cancelCreate");
  }

  private createSocialMedia(): void {
    this.loadingCreate = true;
    this.$store
      .dispatch("socialMedia/createSocialMedia", {
        socialMediaName: this.name,
        socialMediaIcon: this.icon,
        socialMediaUrl: this.url
      })
      .then((response: boolean) => {
        if (response) {
          this.snackbarSuccessCreate = true;
          this.$refs.formCreate.reset();
        } else {
          this.snackbarErrorCreate = true;
        }

        this.loadingCreate = false;
        this.$emit("cancelCreate");
      });
  }

  private openMaterialDesignIcons(): void {
    window.open(process.env.VUE_APP_MATERIAL_DESIGN_ICON);
  }
}
